import { FormattedMessage, useIntl } from '@faceup/localization'
import { ReportStatusTag } from '@faceup/report'
import { Card } from '@faceup/ui'
import { Collapse, Typography } from '@faceup/ui-base'
import moment from 'moment-timezone'
import { useCustomValues } from '../../hooks/useCustomValues'
import { reportStatusMessages } from '../../Shared/translations'
import { messages } from './messages'
import { SummaryField } from './SummaryField'

const PREVIEW_PLACEHOLDER = 'XXXXXX'

export const ReportSummaryPreview = () => {
  const { formatMessage } = useIntl()
  const customValues = useCustomValues()
  const now = new Date()
  const isAnonymous = customValues?.anonymityPreselected ?? false
  const senderValue = isAnonymous ? (
    <FormattedMessage message={messages.anonymous} />
  ) : (
    PREVIEW_PLACEHOLDER
  )

  return (
    <Card className='p-8 w-full flex flex-col gap-8'>
      <Typography.Title level={4} className='!m-0'>
        <FormattedMessage message={messages.title} />
      </Typography.Title>

      <div className='bg-colorFillTertiary rounded-xl pt-4 pb-6 px-6'>
        <div className='grid grid-cols-1 sm:grid-cols-2 gap-3'>
          <SummaryField
            label={<FormattedMessage message={messages.reportId} />}
            value={`#${PREVIEW_PLACEHOLDER}`}
          />
          <SummaryField
            label={<FormattedMessage message={messages.status} />}
            value={<ReportStatusTag name={formatMessage(reportStatusMessages.New)} color='green' />}
          />
          <SummaryField
            label={<FormattedMessage message={messages.reported} />}
            value={moment(now).format('LLL')}
          />
          <SummaryField
            label={<FormattedMessage message={messages.lastAction} />}
            value={moment(now).format('LLL')}
          />
          <SummaryField
            label={<FormattedMessage message={messages.senderIdentity} />}
            value={senderValue}
          />
        </div>
      </div>

      <Collapse
        bordered
        items={[
          {
            key: 'sentInformation',
            label: (
              <Typography.Text strong>
                <FormattedMessage message={messages.sentInformation} />
              </Typography.Text>
            ),
            children: null,
            collapsible: 'disabled',
            showArrow: false,
          },
        ]}
      />
    </Card>
  )
}
